import { createStore, compose, applyMiddleware, Reducer } from 'redux'
import thunk from 'redux-thunk'
import { createLogger } from 'redux-logger'
import { persistStore } from 'redux-persist'

const loggerFilter = (getState: any, action: any) => {
	if (action.type.startsWith('persist')) {
		return false
	}
	if (action.type === '@@redux-form/REGISTER_FIELD') {
		return false
	}
	return action.type !== '@@redux-form/UNREGISTER_FIELD'
}

const configureStore = (rootReducer: Reducer) => {
	const isDev = process.env.NODE_ENV === 'development'
	const logger = createLogger({
		collapsed: true,
		duration: true,
		predicate: loggerFilter
	})
	// eslint-disable-next-line no-underscore-dangle
	const devToolsCompose = isDev && (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
	const composeEnhancers = devToolsCompose ? devToolsCompose({ trace: true, traceLimit: 25 }) : compose
	const store = createStore(rootReducer, composeEnhancers(isDev ? applyMiddleware(thunk, logger) : applyMiddleware(thunk)))
	const persistor = persistStore(store)

	return {
		store,
		persistor
	}
}

export default configureStore
